import { isFeatureEnabled } from 'stores/features-list-store';
import { isSharedAccount } from 'stores/user-store';
import { restrictions } from 'state/features-list/constants';
import { testableFeaturesEnabled } from 'globals/testable';

// Shared by the Care Path card and the route guard so the two can never drift.
// TMH-5076 drops the testable half once the feature key is live.
export const isWlsSchedulingEnabled = (): boolean =>
  isFeatureEnabled(restrictions.wpo_wls_scheduling) &&
  testableFeaturesEnabled();

export const shouldGrantAccessToWlsAppointmentsFlow = async () => {
  if (isSharedAccount()) {
    return { provideAccess: false, redirectTo: 'limitedAccount' };
  }

  return isWlsSchedulingEnabled()
    ? { provideAccess: true, redirectTo: '' }
    : { provideAccess: false, redirectTo: 'pageNotFound' };
};
